import { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useSchoolReportModulesUIContext } from "../SchoolReportModulesUIContext";

const prepareFilter = (queryParams, values) => {
  const { module, order } = values;
  const newQueryParams = { ...queryParams };
  newQueryParams.module = module;
  newQueryParams.order = order;
  return newQueryParams;
};

export function SchoolReportModulesFilter() {
  // School Report Modules UI Context
  const schoolReportModulesUIContext = useSchoolReportModulesUIContext();
  const schoolReportModulesUIProps = useMemo(() => {
    return {
      setQueryParams: schoolReportModulesUIContext.setQueryParams,
      queryParams: schoolReportModulesUIContext.queryParams,
    };
  }, [schoolReportModulesUIContext]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(schoolReportModulesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, schoolReportModulesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      schoolReportModulesUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        module: "",
        order: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="module"
                placeholder="Modül"
                onBlur={handleBlur}
                value={values.module}
                onChange={(e) => {
                  setFieldValue("module", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Modül</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="order"
                min={1}
                placeholder="Sıra"
                onBlur={handleBlur}
                value={values.order}
                onChange={(e) => {
                  setFieldValue("order", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sıra</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}